import React from 'react';
import { Container } from './ui/Container';
import { Moon, Heart, Battery, ShieldCheck, Zap, Smile } from 'lucide-react';
import { Button } from './ui/Button';
const benefits = [{
  icon: Moon,
  title: 'Stop Snoring Naturally',
  desc: 'No machines, masks, or invasive procedures.'
}, {
  icon: Heart,
  title: 'Sleep in the Same Bed',
  desc: 'End the separate rooms and loneliness.'
}, {
  icon: Battery,
  title: 'Wake Up Rested',
  desc: 'Experience deeper, uninterrupted sleep.'
}, {
  icon: Smile,
  title: 'Save Your Relationship',
  desc: 'No more morning fights or resentment.'
}, {
  icon: Zap,
  title: 'Comfortable from Night One',
  desc: 'Soft, moldable fit that feels natural.'
}, {
  icon: ShieldCheck,
  title: 'Risk-Free Trial',
  desc: '60-day money-back guarantee.'
}];
export function BenefitsSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-16 bg-gray-50" data-id="element-1">
      <Container data-id="element-2">
        <div className="text-center mb-12" data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-4">
            What You'll Experience
          </h2>
          <div className="w-20 h-1 bg-blue-600 mx-auto rounded-full" data-id="element-5"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-6">
          {benefits.map((benefit, index) => <div key={index} className="bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition-shadow border border-gray-100" data-id="element-7">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4 text-blue-600" data-id="element-8">
                <benefit.icon className="w-6 h-6" data-id="element-9" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-10">
                {benefit.title}
              </h3>
              <p className="text-gray-600" data-id="element-11">{benefit.desc}</p>
            </div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-12">
          <Button onClick={scrollToPricing} size="lg" className="shadow-lg shadow-blue-900/20" data-id="element-13">
            Get SnoreStop™ Now
          </Button>
        </div>
      </Container>
    </section>;
}